export default "__VITE_ASSET__lfE3CIsb__"